const whichTransitionEvent = () => {
	let t;
	const el = document.createElement('fakeelement');
	const transitions = {
		transition: 'transitionend',
		OTransition: 'oTransitionEnd',
		MozTransition: 'transitionend',
		WebkitTransition: 'webkitTransitionEnd',
	};

	Object.keys(transitions).map((key) => {
		if (el.style[key] !== undefined) {
			t = transitions[key];
		}
		return null;
	});

	return t;
};

const transitionEvent = whichTransitionEvent();
const hoverItemMouseOver = (e) => {
	const query = window.matchMedia('(max-width: 768px)');
	if (!query.matches) {
		e.target.classList.add('hovering');
		e.target.classList.add('animating');

		const multiplier = Math.ceil(e.target.querySelector('.hover-item-details-js').clientHeight / 170);
		const newHeight = (multiplier * 170) + 130;
		e.target.querySelector('.hover-item-content-js').style.height = `${newHeight}px`;
	}
};

const hoverItemMouseOut = (e) => {
	e.target.querySelector('.hover-item-content-js').removeAttribute('style');
	e.target.classList.remove('hovering');
};

const hoverItemAnimationEnd = (e) => {
	if (!e.target.parentElement.classList.contains('hovering')) {
		e.target.parentElement.classList.remove('animating');
	}
};

const hoverListItems = Array.from(document.querySelectorAll('.hover-item-js'));
hoverListItems.forEach((item) => {
	item.addEventListener('mouseenter', e => hoverItemMouseOver(e));
	item.addEventListener('mouseleave', e => hoverItemMouseOut(e));
	item.addEventListener(transitionEvent, e => hoverItemAnimationEnd(e));
});

if (document.querySelector('.hover-list-input-js')) {
	document.querySelector('.hover-list-input-js').addEventListener('keyup', (e) => {
		e.preventDefault();
		const searchResults = Array.from(document.querySelectorAll('.hover-item-js'));
		const searchQuery = e.target.value.toLowerCase();
		searchResults.forEach((item) => {
			const teacherName = item.dataset.name.toLowerCase();
			if (teacherName.indexOf(searchQuery) !== -1) {
				item.classList.remove('item-hidden');
			} else {
				item.classList.add('item-hidden');
			}
		});
	});
}
